import { BaseDrawerLoaderWrapper } from '@/features/drawer/components/BaseDrawer/components/BaseDrawerLoader/BaseDrawerLoader.styles';
import { Loader } from '@/components/feedback/Loader/Loader';

export const BaseDrawerLoader = () => {
  return (
    <BaseDrawerLoaderWrapper>
      <Loader hasLoadingText={false} />
    </BaseDrawerLoaderWrapper>
  );
};
